import { twMerge } from "tailwind-merge";
import type { TRecurrenceButtonActions } from "@/components/atoms/RecurrenceButton/types";
import { recurrenceVariants } from "@/components/atoms/RecurrenceButton/variables";

type TUpdateRecurrenceButtons = {
  target: HTMLButtonElement;
  action: TRecurrenceButtonActions;
};

export const updateRecurrenceButtons = ({
  target,
  action,
}: TUpdateRecurrenceButtons) => {
  const { wrapperClass, textClass } = recurrenceVariants[action];

  target.className = twMerge(target.className, wrapperClass);
  target.disabled = action === "active";

  const text = target.querySelector("#text-recurrence-button");
  if (text) text.className = twMerge(text.className, textClass);
};
